import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const viewDiscountStyle = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    content: {
        flex: 1,
        gap: 16,
        padding: 12
    },
    column: {
        gap: 16
    },
    // ── Cards ────────────────────────────────────────────────────────────────
    card: {
        backgroundColor: appColors.light,
        borderRadius: 12,
        padding: 16,
        elevation: 2,
        shadowColor: appColors.dark,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8
    },
    sectionTitle: {
        fontFamily: appFonts.bold,
        fontSize: 18,
        color: appColors.primary
    },
    sectionSubTitle: {
        fontFamily: appFonts.medium,
        fontSize: fontSize.smallFontSize,
        color: appColors.grey,
        marginTop: 4
    },
    // ── Discount summary ─────────────────────────────────────────────────────
    summaryHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12
    },
    discountIcon: {
        width: 48,
        height: 48,
        borderRadius: 24,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: appColors.tealPrimary
    },
    discountName: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.mediumFontSize,
        color: appColors.lightDark
    },
    chipRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
        marginTop: 6
    },
    chip: {
        paddingVertical: 3,
        paddingHorizontal: 10,
        borderRadius: 12,
        backgroundColor: appColors.coolGray
    },
    chipText: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.primary
    },
    statsRow: {
        flexDirection: 'row',
        gap: 10,
        marginTop: 16
    },
    statTile: {
        flex: 1,
        padding: 12,
        borderRadius: 10,
        backgroundColor: appColors.lightBackgroundColor,
        gap: 6
    },
    statLabel: {
        fontFamily: appFonts.medium,
        fontSize: fontSize.badgeFontSize,
        color: appColors.labelColor
    },
    statValue: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.mediumFontSize,
        color: appColors.lightDark
    },
    createdBy: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        marginTop: 16,
        paddingTop: 14,
        borderTopWidth: 1,
        borderTopColor: appColors.lightBackgroundColor
    },
    // ── Activity log ─────────────────────────────────────────────────────────
    logHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 12
    },
    countBadge: {
        paddingVertical: 3,
        paddingHorizontal: 10,
        borderRadius: 12,
        backgroundColor: appColors.tealPrimary
    },
    logItem: {
        flexDirection: 'row',
        gap: 12,
        paddingVertical: 12,
        borderBottomWidth: 1,
        borderBottomColor: appColors.lightBackgroundColor
    },
    avatar: {
        width: 38,
        height: 38,
        borderRadius: 19,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: appColors.primary
    },
    avatarText: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallFontSize,
        color: appColors.light
    },
    logBody: {
        flex: 1,
        gap: 4
    },
    logTopRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8
    },
    logUser: {
        flex: 1,
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallFontSize,
        color: appColors.lightDark
    },
    logDate: {
        fontFamily: appFonts.medium,
        fontSize: fontSize.badgeFontSize,
        color: appColors.labelColor
    },
    logComment: {
        fontFamily: appFonts.medium,
        fontSize: fontSize.smallFontSize,
        color: appColors.lightDark
    },
    logCommentEmpty: {
        color: appColors.labelColor,
        fontStyle: 'italic'
    },
    footerLoader: {
        height: 50,
        justifyContent: 'center',
        alignItems: 'center'
    }
})
